import { getLogger } from '../services/logger';
import { request } from '../utils';

const logger = getLogger('staylive');

export type StayLiveChannel = {
  id: number;
  name: string;
  path: string;
  image: string;
  expose: number;
  channelImage: string;
};

type StayLiveResponse = {
  message: {
    channels: StayLiveChannel[];
    collection: {
      name: string;
      id: number;
      image: string;
      header_image: string;
      description: string;
    };
  };
  statuscode: number;
  success: boolean;
};

async function fetchChannels() {
  const basePath = `https://api.staylive.tv/collections/feed/67`;

  try {
    const response = await request<StayLiveResponse>(basePath);

    const json = await response.json();

    return json.message.channels || [];
  } catch (error) {
    if (error instanceof Error && error.name === 'AbortError') {
      throw error;
    }
    logger.error('StayLive request failed', { error });
    throw error;
  }
}

export { fetchChannels };
